import React, { Component } from 'react';
import { PDFViewer, Page, Text, Image, Document, View, StyleSheet } from '@react-pdf/renderer';

import { CONSTANCIA } from './Styles/Styles';
import logo from "../../assets/img/logo_menu_black.png";

class ModEstudioSimple extends Component {
    render() {
        let {datos} = this.props;
        const styles = StyleSheet.create(CONSTANCIA[0]);
        let DatPersonales = datos.datosPersonales;
        let nombre2 = "";
        let apellido2 = "";
        (DatPersonales.nombre_2 === null) ? nombre2 = "" : nombre2 = DatPersonales.nombre_2;
        (DatPersonales.apellido_2 === null) ? apellido2 = "" : apellido2 = DatPersonales.apellido_2;
        let Estudiante = `${DatPersonales.nombre_1} ${nombre2} ${DatPersonales.apellido_1} ${apellido2}`;
        let Cedula = `${DatPersonales.nacionalidad} ${DatPersonales.ci}`;
        
        let fecha = () => {
            let fehaEnt = this.props.fecha;
            let fechaPartes = fehaEnt.split("/")
            let meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre' ]
            return `${fechaPartes[0]} días del mes de ${meses[parseInt(fechaPartes[1]) - 1]} de ${fechaPartes[2]}`
        }

        let numLet = ["un", "dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve", "diez"];
        let aPal = "año";
        if (datos.aCursados > 1) aPal = "años";

        return (
            <PDFViewer style={styles.section}>
                <Document title="Constancia de Modalidad de Estudio (Simple)">
                    <Page size="letter" style={styles.body}>
                        <View>
                            <Image style={[styles.logo, {marginBottom: 30}]} src={logo} />
                            <Text style={styles.encabezado2}>INSTITUTO UNIVERSITARIO DE DISEÑO LAS MERCEDES</Text>
                            <Text style={styles.encabezado5}>M.E. Nº 130 G.O. Nº 36.719  9 JUNIO 1.999</Text>

                            <Text style={[styles.encabezado2, {marginTop: 20}]}>CONSTANCIA DE MODALIDAD DE ESTUDIO</Text>

                            <Text style={[styles.parrafo, styles.lineH, {marginTop: 20}]}>
                                Quien suscribe, Dra {datos.nameDir}, titular de la Cédula de Identidad V-{datos.cedulaDir}, en su carácter de Directora del Instituto Universitario De Diseño Las Mercedes, certifica que el (la) ciudadano (a):
                            </Text>

                            <Text style={[styles.nombre, {marginTop: 10, marginBottom: 10}]}>
                                {Estudiante}
                            </Text>

                            <Text style={[styles.parrafo, styles.lineH, {marginTop: 10}]}>
                                Titular de la Cédula de Identidad {Cedula}, cursó en MODALIDAD PRESENCIAL el Programa de {datos.carrera}, de tres (3) años de duración en régimen semestral, en el lapso comprendido entre {datos.lapsoIn} y {datos.lapsoOut}, aprobando {datos.ucApL} ({datos.ucAp}) Unidades de Crédito que lo acreditaron para obtener el título de Técnico Superior Inivesritario en {datos.carrera}.
                            </Text>

                            <Text style={[styles.parrafo, styles.lineH, {marginTop: 10}]}>
                                Constancia que se expide a solicitud de la parte interesada, en Caracas, a los {fecha()}.
                            </Text>

                            <Text style={[styles.firma, {marginTop: 60}]}> {datos.nameDir}</Text>
                            <Text style={[styles.firma, {marginTop: -5}]}> Directora </Text>

                            <View style={[styles.footer3]}>
                                <View style={[styles.row]}>
                                    <View style={[styles.col11]}>
                                        <Text style={[styles.linea3]}></Text>
                                        <Text style={[styles.encabezado, {fontSize: 7}]}>
                                            Av. Río de Janeiro con Calle Roraima, quinta Los Abuelos, N° 78, Urbanización Chuao, 
                                            C.P.1061  Edo Miranda - Caracas - Venezuela
                                        </Text>
                                        <Text style={[styles.encabezado, {marginTop: -5, fontSize: 7}]}>
                                            Telefax: +58 212 9930983 | 9939139 | 9910710.
                                        </Text>
                                    </View>
                                </View>
                            </View>
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        );
    }
}

export default ModEstudioSimple;


// WEBPACK FOOTER //
// ./src/components/Reportes/ModEstudioSimple.jsx